import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useNavigate, useParams } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import { GlobalContext } from '../../../library/Core/GlobalContext';
import SessionContext from '../../../library/Core/SessionContext';
import { SmartContext } from '../../../library/Core/SmartContext';
import smartReducer from '../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../library/Core/SmartTypes';
import { handleInstituteSelection } from './AdminInstituteSectionActions';
import AdminInstituteSelectionLayout from './AdminInstituteSelectionLayout';
import { addUserSpecificDomains } from '../../../library/Service/domainService';
import DebugBarControl from '../../../library/SimpleControls/DebugBarControl';
import { getFlexColDomainValueForCode, isEmpty } from '../../../library/Core/SmartFunctions';

const AdminInstituteSelection = ({pageTitle}:any) => {
    document.title=pageTitle;
    const { globalState, globalDispatch } = useContext(GlobalContext);
    const { sessionState, sessionDispatch } = useContext(SessionContext);
    const { instituteId, redirectTo } = useParams();
    const navigate = useNavigate();
    // const [shouldNavigate, setShouldNavigate] = useState(false);
    const { formConfig, data, internal, routeInfo } = useLoaderData() as State;
    const [allInstitutes, setAllInstitutes] = useState<any[]>([]);
    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {
            ROUTER_NAVIGATE: navigate,
        },
    } as any);

    useEffect(() => {
        const domain = addUserSpecificDomains(new Map([...globalState.domain]), data);
        dispatch({
            type: 'DATA_INIT',
            payload: { formConfig, data, domain, routeInfo },
        });
    },[]);

    // useEffect(() => {
    //     if (shouldNavigate) {
    //         const institute = sessionState;
    //         if (institute && Object.keys(institute).length > 1) {
    //             const navigateToUrl: string = navigateToLandingPage(institute, institute.studentId) as string;
    //             navigate(navigateToUrl);
    //             setShouldNavigate(false);
    //         }
    //     }
    // }, [shouldNavigate, navigate, sessionState]);

    const handleSelection = (institute: any) => {
        handleInstituteSelection(institute, data?.id, state, dispatch , redirectTo)
        // .then(() => {
        //     setShouldNavigate(true); 
        // });
    };

    useEffect(() => {
        const institutes: any[] = [];
        data?.userInstitutes.map((institute:any) => {
            let flexCol = getFlexColDomainValueForCode(institute.instituteId, 'INSTITUTE_DOMAIN', state);
            let instGroupId = isEmpty(flexCol) ? '' : JSON.parse(flexCol).institute_group_id;
            if (institute?.userStatusCode == 'INACTIVE' ||(sessionState?.role == 'INSTITUTE_ADMIN' && sessionState?.instituteGroupId !== instGroupId)) {
                return;
            }

            institutes.push(institute);
        });
        setAllInstitutes(institutes);

        const instituteIdfromParam = institutes.find((inst:any) => inst.instituteId == instituteId)
        if(instituteIdfromParam){
            handleInstituteSelection(instituteIdfromParam, data?.id, state, dispatch, redirectTo);
            return;
        }

        // if (data?.userInstitutes.length === 1) {
        if (institutes.length === 1) {
            handleSelection(institutes[0]);
            // setShouldNavigate(false); 
        }
    }, [state.data?.userInstitutes]);
    
    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <AdminInstituteSelectionLayout handleSelection={handleSelection} institutesLength={allInstitutes?.length} userData={data}>
            </AdminInstituteSelectionLayout>
            <DebugBarControl />
        </SmartContext.Provider>
    );
};

export default AdminInstituteSelection;
